	export enum EarSideExtendedEnum {
		Right = 1,
		Left = 2,
		Binaural = 3
	}
